// src/host/services/session.service.ts - UPDATED to generate session ID

import { ApiService } from '@shared/services/api.service';
import { useSessionStore } from '@host/stores/session.store';
import { useAuthStore } from '@host/stores/auth.store';

export const initializeSessionAfterLogin = async (orgSlugPid: string) => {
  const token = await useAuthStore.getState().getToken();
  if (!token) throw new Error('Missing auth token');

  const {
    orgPid,
    orgSlug: resolvedOrgSlug,
    redirectTo,
    platform_role,
  } = await ApiService.post<{
    orgPid: string;
    orgSlug: string;
    redirectTo: string;
    platform_role: string;
  }>(
    '/welcome/auth/init',
    { orgSlugOrPid: orgSlugPid },
    {
      config: { headers: { Authorization: `Bearer ${token}` } },
    }
  );

  if (!orgPid || !resolvedOrgSlug) throw new Error('Invalid session init response');

  console.log('[SessionService] Session initialized:', {
    orgPid,
    orgSlug: resolvedOrgSlug,
    redirectTo,
  });

  useSessionStore
    .getState()
    .setSession(orgPid, resolvedOrgSlug, redirectTo ?? `/${resolvedOrgSlug}/workplace`);

  return {
    redirectTo: redirectTo ?? `/${resolvedOrgSlug}/workplace`,
    platform_role,
  };
};
